// extracted by mini-css-extract-plugin
module.exports = {"description":"section-name_description__0z1V7","light":"section-name_light__RWlyR"};